import React, { useState, useEffect } from "react";
import "./OrchesApproach.css";
import img from "../orchesassets/approach.png";

export default function OrchesApproach() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(3);
    
  const cases = [
    {
     name: "Application Containerization",
      text: "Evaluate applications, dependencies, and orchestration requirements.",
    },
    {
      name: "Container Orchestration",
      text: "Design Kubernetes-based orchestration architectures tailored to your environment.",
    },
    {
     name: "CI/CD Integration",
      text: "Implement scaling, security, and governance policies.",
    },
     {
      name: "Security & Compliance",
      text: "Connect orchestration platforms with DevOps pipelines and monitoring tools.",
    },
    {
      name: "Cloud & Hybrid Deployment",
      text: "Continuously monitor performance and optimize orchestration workflows.",
    },
  ];

  const maxSlides = Math.max(0, cases.length - cardsToShow);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setCardsToShow(3);
      } else if (window.innerWidth >= 576) {
        setCardsToShow(2);
      } else {
        setCardsToShow(1);
      }
      setCurrentSlide(0);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDotClick = (index) => {
    if (index <= maxSlides) {
      setCurrentSlide(index);
    }
  };

  return (
    <div id="orches-approach" className="outsourcemainclass">
       <button className="btn">Let's Discuss Your Project</button>
      <h2 className="heading">
        Why Choose BastionEx?
      </h2>
      <p className="subheading">
      Delivering Secure, Compliant, and High-Performance CI Solutions
      </p>

      <div className="cards">
        {cases.map((item, index) => (
          <div className="card" key={index}>
            <img src={img} alt="error" />
            <span>{item.name}</span>
            <p className="text">{item.text}</p>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{
              transform: `translateX(calc(-${(100 / cardsToShow) * currentSlide}% - ${currentSlide * 12}px))`,
            }}
          >
            {cases.map((item, index) => (
              <div
                className="card"
                key={index}
                style={{
                  flex: `0 0 calc(${100 / cardsToShow}% - ${
                    ((cardsToShow - 1) * 12) / cardsToShow
                  }px)`,
                }}
              >
                <img src={img} alt="error" />
                <span>{item.name}</span>
                <p className="text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {maxSlides > 0 && (
          <div className="carousel-dots">
            {Array.from({ length: maxSlides + 1 }).map((_, index) => (
              <button
                key={index}
                className={`dot ${currentSlide === index ? "active" : ""}`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}